import Request from '@request'
import api from '@api'
import os from '@utils/os.js'

import { NativeMessageNotice, NativeMessageData } from '@utils/nativeBridge/nativeMessage'
import { clearCookie } from '@utils/cookie'
import javaRequest from '@utils/request/javaRequest'

function loginBase ({ dispatch, commit, params, state, rootState, url }) {
    // if (os.isWechat() === 3) {
    //     delete params['openid']
    //     delete params['unionid']
    // }
    return new Promise(async (resolve, reject) => {
        // if (state.isLogin) {
        //     await dispatch('socket/setIsListeningAccount', false, {
        //         root: true
        //     })
        // }

        javaRequest
            .post(url, params)
            .then(async res => {
                commit('setUserLoginData', res)
                commit('setLogin', true)
                // 更新设备id
                rootState.socket.socket.login()
                if (rootState.common.isInApp) {
                    let systemInfo = rootState.nativeBridge.nativeBridge.sendMessage(
                        new NativeMessageData({
                            type: 'systemInfo'
                        })
                    )

                    let device_token = ''

                    if (os.isIOS()) {
                        device_token = JSON.parse(JSON.parse(systemInfo).systemInfo).device_token
                    } else {
                        //安卓
                        device_token = JSON.parse(systemInfo).device_token
                    }

                    console.log(
                        {
                            equipmentCode: device_token,
                            userType: state.isLogin ? 0 : 1,
                            equipmentType: os.getDevice() == 'ios' ? 1 : 0
                        },
                        '============='
                    )

                    javaRequest
                        .post(
                            '/departmental-consortium/Equipments',
                            {
                                equipmentCode: device_token,
                                equipmentType: os.getDevice() == 'ios' ? 1 : 0
                            },
                            false
                        )
                        .then(res => { })

                    // dispatch('messagePush/insertEquipmentRecord', {
                    //     equipmentCode: device_token,
                    //     equipmentType: os.getDevice() == 'ios' ? 1 : 0
                    // }, { root: true })
                }

                // 获取未读消息数
                // dispatch('messagePush/getMessagePush', {
                //     pageNum: 1,
                //     pageSize: 10,
                //     messageRecordStatus: 0
                // }, { root: true })
                // 重新获取身份
                // await dispatch('getUserInfos', true).catch(_ => _)
                // dispatch('socket/login', undefined, {
                //     root: true
                // }).catch(_ => _)

                // await dispatch('checkUserIdentity').catch(_ => _)

                rootState.nativeBridge.nativeBridge.sendMessage(
                    new NativeMessageNotice({
                        type: 'login',
                        params: {
                            userInfo: {
                                ...res.data,
                                ...state.userInfos
                            }
                        }
                    })
                )

                resolve(res)
            })
            .catch(res => {
                // dispatch('socket/login', undefined, {
                //     root: true
                // }).catch(_ => _)
                reject(res)
            })
    })
}

export default {
    login ({ dispatch, commit, state, rootState }, params) {
        return loginBase({
            dispatch,
            commit,
            params,
            state,
            rootState,
            url: '/hospro/login'
        })
    },
    loginCode ({ dispatch, commit, state, rootState }, params) {
        return loginBase({
            dispatch,
            commit,
            params,
            state,
            rootState,
            url: '/hospro/phoneLogin'
        })
    },
    phoneVerifyLogin ({ dispatch, commit, state, rootState }, params) {
        return loginBase({
            dispatch,
            commit,
            params,
            state,
            rootState,
            url: api.common.phoneVerifyLogin
        })
    },
    logout ({ dispatch, commit, state, rootState }, params) {
        return new Promise((resolve, reject) => {
            commit('setLogin', false)
            commit('setUserInfos', undefined)

            commit('setDict', [], { root: true })
            // let func = () => {

            // if (rootState.common.isInApp) {

            // // 更新设备id
            // let systemInfo = rootState.nativeBridge.nativeBridge.sendMessage(new NativeMessageData({
            //     type: 'systemInfo'
            // }))
            // console.log(systemInfo)
            // let device_token = ''

            // if (os.isIOS()) {
            //     device_token = JSON.parse(JSON.parse(systemInfo).systemInfo).device_token
            // } else {//安卓
            //     device_token = JSON.parse(systemInfo).device_token
            // }

            rootState.nativeBridge.nativeBridge.sendMessage(
                new NativeMessageNotice({
                    type: 'logout'
                })
            )
            rootState.nativeBridge.nativeBridge.sendMessage(
                new NativeMessageNotice({
                    type: 'badge',
                    params: {
                        count: 0
                    }
                })
            )
            // const userID = localStorage.getItem('userID')

            localStorage.removeItem('userID')
            localStorage.removeItem('token')
            localStorage.removeItem('dicts')
            resolve()

            // } else {
            //     removeUserInfoFunc()
            // }
            // }

            // javaRequest
            //     .delete('/hospro/logout')
            //     .then(res => {
            // func()
            // }).catch(err => {
            //     func()
            // })
        })
    },

    getLoginStatus ({ dispatch, commit, state, rootState }, info) {
        return new Promise((resolve, reject) => {
            if (!localStorage.getItem('userID')) {
                commit('setLogin', false)
                resolve()
                if (rootState.common.isInApp) {
                    // rootState.nativeBridge.nativeBridge.sendMessage(new NativeMessageNotice({
                    //     type: 'badge',
                    //     params: {
                    //         count: 0
                    //     }
                    // }))
                }
            } else {
                commit('setLogin', true)
                resolve(true)
                //     Request.post(
                //         api.common.getLoginStatus, {}, false).then(res => {
                //             commit('setLogin', true)

                //             resolve(true)
                //         }).catch(status => {
                //             if (status == 401) {
                //                 dispatch('logout')
                //                 rootState.nativeBridge.nativeBridge.sendMessage(new NativeMessageNotice({
                //                     type: 'badge',
                //                     params: {
                //                         count: 0
                //                     }
                //                 }))
                //                 commit('setLogin', false)
                //                 reject(status)
                //             }
                //             else {
                //                 resolve(true)
                //             }
                //         })
            }
        })
    },
    getUserInfos ({ dispatch, commit, state, rootState }, params = {}) {
        return new Promise((resolve, reject) => {
            //获取科联体
            javaRequest.get('/departmental-consortium/departments/union', params).then(res => {
                if (res.data && res.data.length > 0) {
                    let info = res.data[0]
                    // commit('setUserInfos', info)

                    //获取医生信息
                    javaRequest
                        .selinfoPost({
                            params: {
                                hospitalID: info.hospitalID,
                                doctorID: info.doctorID,
                                pageNum: 1,
                                pageSize: 1
                            },
                            hospitalID: info.hospitalID,
                            func: 'fGetDoctorList'
                        })
                        .then(data => {
                            let params = { info }
                            if (data.DoctorList && data.DoctorList.length > 0) {
                                let docotrData = data.DoctorList[0]
                                params = {
                                    ...docotrData,
                                    ...info, //顺序千万不要换
                                    isAuth: true,
                                    deptUnionId: info.id,
                                    userId: docotrData.id
                                }
                                console.log(params)
                            }
                            dispatch('getDict', params.hospitalID, { root: true })
                            commit('setUserInfos', params)
                            resolve(params)

                            if (rootState.common.isInApp) {
                                // if (needSelectCollege && res.data.home_selected_college == 3 && rootState.home.collegeID == 0) {
                                //     commit('home/setCollegeID', res.data.home_selected_college, {
                                //         root: true
                                //     })
                                // }

                                rootState.nativeBridge.nativeBridge.sendMessage(
                                    new NativeMessageNotice({
                                        type: 'userInfo',
                                        params: {
                                            userInfo: {
                                                ...params,
                                                // deptUnionId: rootState.common.deptUnionId,
                                                userid: localStorage.getItem('userID'),
                                                Authorization: 'Bearer ' + localStorage.getItem('token')
                                            }
                                        }
                                    })
                                )
                            }
                        })
                } else {
                    let params = {
                        isAuth: false
                    }
                    commit('setUserInfos', params)
                    resolve(params)
                }
                // if (res.data.user_type || res.data.user_type == 0) {
                // commit('setUserIdentity', res.data.user_type)
                // resolve(state.user_identity)
                // } else {
                //     resolve(-1)
                // }
            })
        })
    },
    setUserMessage ({ dispatch, commit, state, rootState }, params) {
        return new Promise((resolve, reject) => {
            Request.post(api.user.setUserMessage, params).then(res => {
                resolve(res)
            })
        })
    },
    uploadImg ({ dispatch, commit, state, rootState }, params) {
        return new Promise((resolve, reject) => {
            Request.post(api.common.uploadImg, params)
                .then(res => {
                    resolve(res)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },
    destory ({ dispatch, commit, state }, info) {
        return new Promise((resolve, reject) => {
            Request.post(api.common.destory).then(res => {
                dispatch('logout')
                resolve(res)
            })
        })
    }
}
